export default [
  {
    author: 'Florian Hübsch',
    avatar: 'fh',
    medium: 'fh_95229',
    date: 'Mar 16, 2017',
    length: '4 min read',
    title: 'Julia Set Visualization with WebGL for Elm',
    description: 'Creating beautiful fractal animations with Elm',
    preview: '/images/blogposts/4',
    url: 'https://medium.com/ninjaconcept/julia-set-visualization-with-webgl-for-elm-765e5da88626#.2tesn7f64'
  },
  {
    author: 'Marco Sehrer',
    avatar: 'ms',
    medium: 'sushi2kk',
    date: 'Mar 16, 2017',
    length: '3 min read',
    title: '3D Vector Animations in Elm',
    description: 'Having fun with the new OpenSolid package.',
    preview: '/images/blogposts/3',
    url: 'https://medium.com/ninjaconcept/3d-vector-animations-in-elm-58703993d144#.7jfcyyhd7'
  },
  {
    author: 'Johannes Linowski',
    avatar: 'jl',
    medium: 'johanneslinowski',
    date: 'Mar 10, 2017',
    length: '2 min read',
    title: 'How to setup ArangoDB on DigitalOcean with Docker in less than 2 minutes',
    description: 'Let’s kickstart the setup and deploy a ready ArangoDB setup on DigitalOcean with Docker.',
    preview: '/images/blogposts/6',
    url: 'https://medium.com/ninjaconcept/how-to-setup-arangodb-on-digitalocean-with-docker-in-2-minutes-898627da3cb7'
  },
  {
    author: 'Johannes Linowski',
    avatar: 'jl',
    medium: 'johanneslinowski',
    date: 'Feb 24, 2017',
    length: '3 min read',
    title: 'How to quickly setup MongoDB on DigitalOcean',
    description: 'MongoDB is the most popular NoSQL database. Let’s quickly setup a single MongoDB server on an DigitalOcean Droplet in 4 easy steps.',
    preview: '/images/blogposts/5',
    url: 'https://medium.com/ninjaconcept/how-to-quickly-setup-mongodb-on-digitalocean-3d9791a7aaa4'
  },
  {
    author: 'Robin Frischmann',
    avatar: 'rf',
    medium: 'rofrischmann',
    date: 'Feb 13, 2017',
    length: '12 min read',
    title: 'Interactive & Dynamic Force-Directed Graphs with D3',
    description: 'A guided tour through D3 version 4.0 force simulations with dynamic data and user interaction.',
    preview: '/images/blogposts/2',
    url: 'https://medium.com/ninjaconcept/interactive-dynamic-force-directed-graphs-with-d3-da720c6d7811#.75fgw0juc'
  },
  {
    author: 'Robin Frischmann',
    avatar: 'rf',
    medium: 'rofrischmann',
    date: 'Jan 19, 2017',
    length: '1 min read',
    title: 'Ninjas invade Medium',
    description: 'Introducing the NinjaConcept Blog.',
    preview: '/images/blogposts/1',
    url: 'https://medium.com/ninjaconcept/ninjas-invade-medium-3f2a43fe72fa#.hm0bdre7l'
  }
]



// WEBPACK FOOTER //
// ../constants/blogPosts.js